import { __decorate, __extends } from "tslib";
import { Editor } from '@tinymce/tinymce-react';
import { action } from 'mobx';
import { inject, observer } from 'mobx-react';
import React from 'react';
import { getConfig, update } from '../../api/config';
import { Button } from '../../components/Button';
import { SpinnerBlock } from '../../components/Spinner';
import { getEditorKey, getEditorOptions, isHtmlEmpty } from '../../utils/utils';
import S from './products.styl';
var ProductsGuideView = /** @class */ (function (_super) {
    __extends(ProductsGuideView, _super);
    function ProductsGuideView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            loading: false,
            titleError: false,
            contentError: false,
            contentState: '',
        };
        _this.onChangeAction = function (e) {
            var name = e.currentTarget.name;
            if (name === 'title') {
                _this.setState({ titleError: false });
            }
        };
        return _this;
    }
    ProductsGuideView.prototype.onSubmit = function (event) {
        var _this = this;
        event.preventDefault();
        var elements = event.currentTarget.elements;
        var valid = true;
        var title = elements.title.value;
        if (title.length === 0) {
            this.setState({ titleError: true });
            valid = false;
        }
        var html = this.contentRef.getContent();
        if (isHtmlEmpty(html)) {
            this.setState({ contentError: true });
            valid = false;
        }
        if (!valid) {
            return;
        }
        var request = {
            productTitle: title,
            productIntro: html,
        };
        this.setState({ loading: true });
        update(request).then(function (_) {
            _this.fetchData();
        }).catch(function (error) {
            alert(error.toString());
            throw error;
        });
    };
    ProductsGuideView.prototype.componentDidMount = function () {
        var store = this.props.store;
        if (store) {
            this.fetchData();
        }
    };
    ProductsGuideView.prototype.fetchData = function () {
        var _this = this;
        this.setState({ loading: true });
        getConfig().then(function (result) {
            _this.setState({
                loading: false,
                config: result,
            });
            if (result) {
                _this.setState({
                    contentState: result.productIntro || '',
                });
            }
        }).catch(function (error) {
            alert(error.toString());
            throw error;
        });
    };
    ProductsGuideView.prototype.render = function () {
        var _this = this;
        var _a = this, props = _a.props, state = _a.state;
        var loading = state.loading, config = state.config, contentState = state.contentState;
        var i18n = props.store.i18n;
        return (React.createElement("div", { className: S.productsView },
            React.createElement("h1", { className: S.productsTitle }, i18n.sideBarProductsGuide),
            React.createElement("hr", { className: S.productsSeparator }),
            React.createElement("div", { className: S.productsMainBox }, loading ?
                React.createElement(SpinnerBlock, null)
                :
                    React.createElement(React.Fragment, null,
                        React.createElement("form", { className: "" + S.detailsDialogContent, method: "get", action: "/", onSubmit: this.onSubmit, noValidate: true },
                            React.createElement("div", null,
                                React.createElement("p", { className: "formSubtitle" }, i18n.inputTitlePlaceholder),
                                React.createElement("div", { className: S.addInputWrapper },
                                    React.createElement("label", { className: S.addInputTitle }, i18n.inputTitlePlaceholder),
                                    React.createElement("input", { className: S.addInput + " textInput", name: "title", autoComplete: "title", onInput: this.onChangeAction, placeholder: i18n.inputTitlePlaceholder, defaultValue: config === null || config === void 0 ? void 0 : config.productTitle })),
                                React.createElement("p", { className: "inputError " + S.detailsInputError + " " + (this.state.titleError ? 'inputErrorActive' : '') }, i18n.validationTitleError),
                                React.createElement("p", { className: "formSubtitle" }, i18n.inputTitleIntroduction),
                                React.createElement(Editor, { onInit: function (_, editor) { return _this.contentRef = editor; }, apiKey: getEditorKey(), initialValue: contentState, init: getEditorOptions() }),
                                React.createElement("p", { className: "inputError " + S.detailsInputError + " " + (this.state.contentError ? 'inputErrorActive' : '') }, i18n.validationContentError)),
                            React.createElement(Button, { className: "primaryButton fullwidthButton " + S.updateButton, type: "submit", spinner: loading }, i18n.actionUpdate))))));
    };
    __decorate([
        action.bound
    ], ProductsGuideView.prototype, "onSubmit", null);
    ProductsGuideView = __decorate([
        inject('store'),
        observer
    ], ProductsGuideView);
    return ProductsGuideView;
}(React.Component));
export { ProductsGuideView };
